import { Component } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AbstractCrudComponent } from '../../../component/abstract-crud.component';
import { ErrorDialogComponent } from '../../../dialogs/error-dialog/error-dialog.component';
import { LoteNotificacaoSmsDTO } from '../../../dtos/lote-notificacao-sms-dto';
import { CustomDateValidator } from '../../../validators/custom-date-validator';
import { NotificacoesSmsService } from '../../notificacoes-sms.service';

@Component({
  selector: 'app-notificacao-cancelamento-list',
  templateUrl: './notificacao-cancelamento-list.component.html',
  styleUrls: ['./notificacao-cancelamento-list.component.css']
})
export class NotificacaoCancelamentoListComponent extends AbstractCrudComponent {

  displayedColumns: string[] = ['numLote', 'dataNotificacao', 'dscMotivoNotificacao', 'status', 'details'];

  tamanhoDasColunasEmPercent: string[] = ['8%', '17%', '59%', '8%', '8%'];

  formularioDeConsultaDeNotificacoes: FormGroup;

  filtroLoteNotificacaoSms: LoteNotificacaoSmsDTO;

  totalDeCreditosDisponiveis: string = '---';

  constructor(private notificacoesSmsService: NotificacoesSmsService, router: Router,
    dialog: MatDialog, private formBuilder: FormBuilder) {

    super(router, dialog);

    this.filtroLoteNotificacaoSms = history.state.filtroLoteNotificacaoSms;
    if (this.filtroLoteNotificacaoSms) {
      this.filtroLoteNotificacaoSms = Object.assign(new LoteNotificacaoSmsDTO(), this.filtroLoteNotificacaoSms);
    }

    this.formularioDeConsultaDeNotificacoes = this.formBuilder.group({
      dataInicialLoteNotificacao: [null],
      dataFinalLoteNotificacao: [null],
      numLote: [null],
      dscMotivoNotificacao: [null],
    }, {
      validator: [CustomDateValidator('dataInicialLoteNotificacao'),
      CustomDateValidator('dataFinalLoteNotificacao')],
    });
  }

  ngOnInit() {

    this.atualizarCreditosDisponiveis();

    if (this.filtroLoteNotificacaoSms && this.filtroLoteNotificacaoSms.temFiltroPreenchido()) {

      this.formularioDeConsultaDeNotificacoes.controls.dataInicialLoteNotificacao.setValue(this.filtroLoteNotificacaoSms.dataInicialLoteNotificacao);
      this.formularioDeConsultaDeNotificacoes.controls.dataFinalLoteNotificacao.setValue(this.filtroLoteNotificacaoSms.dataFinalLoteNotificacao);
      this.formularioDeConsultaDeNotificacoes.controls.numLote.setValue(this.filtroLoteNotificacaoSms.numLote);
      this.formularioDeConsultaDeNotificacoes.controls.dscMotivoNotificacao.setValue(this.filtroLoteNotificacaoSms.dscMotivoNotificacao);

      this.reloadData(this.filtroLoteNotificacaoSms);
    }

    super.ngOnInit();
  }

  reloadData(filtroLoteNotificacaoSms: LoteNotificacaoSmsDTO) {

    if (!filtroLoteNotificacaoSms || !filtroLoteNotificacaoSms.temFiltroPreenchido()) {

      this.dialog.open(ErrorDialogComponent, {
        data: {
          title: 'Erro',
          message: 'Selecione pelo menos um campo de filtro!'
        }
      });

    } else {

      this.notificacoesSmsService.procurarLoteNotificacaoSmsFiltro(filtroLoteNotificacaoSms)
        .subscribe(data => {

          const listaLoteNotificacaoSms: Array<LoteNotificacaoSmsDTO> = [];

          data.forEach((element: any) => {
            listaLoteNotificacaoSms.push(Object.assign(new LoteNotificacaoSmsDTO(), element));
          });

          this.data = listaLoteNotificacaoSms;

          this.configurarDataSource();
        }, error => {
          console.log(error);
        });

    }
  }

  onSubmit() {
    this.filtroLoteNotificacaoSms = Object.assign(new LoteNotificacaoSmsDTO(), this.formularioDeConsultaDeNotificacoes.value);

    this.reloadData(this.filtroLoteNotificacaoSms);
  }

  add() {
    const loteNotificacaoSmsDTO: LoteNotificacaoSmsDTO = this.formularioDeConsultaDeNotificacoes.value;

    this.router.navigate(['criarLoteNotificacaoSms'], {
      state: {
        filtroLoteNotificacaoSms: loteNotificacaoSmsDTO,
      }
    });
  }

  details(dto: LoteNotificacaoSmsDTO) {

    const loteNotificacaoSmsDTO: LoteNotificacaoSmsDTO = this.formularioDeConsultaDeNotificacoes.value;

    this.router.navigate(['detalharLoteNotificacaoSms'], {
      state: {
        dto: dto,
        filtroLoteNotificacaoSms: loteNotificacaoSmsDTO,
      }
    });
  }

  onResize(event: any) {

    super.onResize(event);

    this.configurarLargurasDasColunasDaTabela(event.target.innerWidth);

  }

  atualizarCreditosDisponiveis(): void {

    this.notificacoesSmsService.consultarCreditosSms()
      .subscribe(data => {

        if (data) {
          this.totalDeCreditosDisponiveis = data;
        } else {
          this.totalDeCreditosDisponiveis = '0';
        }

      }, error => {

        this.totalDeCreditosDisponiveis = '---';

        console.log(error);
      });

  }

  configurarLargurasDasColunasDaTabela(innerWidth: any): void {

    if (innerWidth < 586) {

      this.tamanhoDasColunasEmPercent = ['13%', '22%', '49%', '8%', '8%'];

    } else if (innerWidth < 620) {

      this.tamanhoDasColunasEmPercent = ['10%', '22%', '52%', '8%', '8%'];

    } else if (innerWidth < 780) {

      this.tamanhoDasColunasEmPercent = ['10%', '17%', '57%', '8%', '8%'];

    } else {

      this.tamanhoDasColunasEmPercent = ['8%', '17%', '59%', '8%', '8%'];

    }

  }

}
